import * as React from "react";
import "../scss/departureheader.scss"
import GlobalConfiguration from "../controllers/model/GlobalConfiguration"
import DepartureHeaderEntryComponent from "./DepartureHeaderEntryComponent"
export interface DepartureHeaderProps {

}

export class DepartureHeaderCompoment extends React.Component<DepartureHeaderProps, {}> {
    render() {
        return (
            <div className="departure-header-container">
                {GlobalConfiguration.Config.map((item, i) => {
                    return (this.renderDepartureHeaderEntries(item))
                })}
            </div>
        );
    }
    renderDepartureHeaderEntries(item: any) {
        return (
            <DepartureHeaderEntryComponent key={item.key} germanHeaderText={item.headerTextGerman} englishHeaderText={item.headerTextEnglish}
                width={item.width} textAlignment={item.textAlignment}></DepartureHeaderEntryComponent>
        )
    }
}

export default DepartureHeaderCompoment;